import React from 'react'
import InlineSVG from 'svg-inline-react'

const ieLogo = props => (
  <InlineSVG
    style={{ height: '95%', width: 50 }}
    src={`<svg viewBox="0 0 934 934" >
<path
  d="M467 0C209.5 0 0 209.5 0 467s209.5 467 467 467 467-209.5 467-467S724.5 0 467 0zM92 467c0-192.75 146.25-351.93 333.58-372.62V285l-39.35-49.59a46 46 0 1 0-72.1 57.2l111.45 140.51v79l-97.86-89.38a46 46 0 0 0-62.07 68L425.58 636.8v73L283.9 590.65a46 46 0 1 0-59.23 70.45l212.41 178.6c.48.4 1.06.69 1.57 1.08C245.1 826.22 92 664.21 92 467zm403.46 373.77c.3-.23.63-.39.92-.62L708.79 667a46 46 0 1 0-58.15-71.35L508.42 711.58v-74.82l162-148.63a46 46 0 0 0-62.24-67.81l-99.71 91.51v-78.68L617 297.07a46 46 0 0 0-72-57.4l-36.63 45.91V94.38C695.75 115.07 842 274.25 842 467c0 197.17-153 359.16-346.54 373.77z"
  fill=${props.color ? props.color : '#fff'}
/>
</svg>`}
  />
)

const logo = props => (
  <svg viewBox="0 0 934 934" {...props}>
    <path
      d="M467 0C209.5 0 0 209.5 0 467s209.5 467 467 467 467-209.5 467-467S724.5 0 467 0zM92 467c0-192.75 146.25-351.93 333.58-372.62V285l-39.35-49.59a46 46 0 1 0-72.1 57.2l111.45 140.51v79l-97.86-89.38a46 46 0 0 0-62.07 68L425.58 636.8v73L283.9 590.65a46 46 0 1 0-59.23 70.45l212.41 178.6c.48.4 1.06.69 1.57 1.08C245.1 826.22 92 664.21 92 467zm403.46 373.77c.3-.23.63-.39.92-.62L708.79 667a46 46 0 1 0-58.15-71.35L508.42 711.58v-74.82l162-148.63a46 46 0 0 0-62.24-67.81l-99.71 91.51v-78.68L617 297.07a46 46 0 0 0-72-57.4l-36.63 45.91V94.38C695.75 115.07 842 274.25 842 467c0 197.17-153 359.16-346.54 373.77z"
      fill={props.color ? props.color : '#fff'}
    />
  </svg>
)

let isIE = false
if (
  (typeof navigator != 'undefined' &&
    navigator.appName == 'Microsoft Internet Explorer') ||
  !!(
    typeof navigator != 'undefined' &&
    (navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/))
  ) ||
  (typeof $ !== 'undefined' &&
    typeof $.browser !== 'undefined' &&
    $.browser.msie == 1)
) {
  isIE = true
}

export default (isIE ? ieLogo : logo)



// WEBPACK FOOTER //
// ./src/components/shared/logo.js